module.exports = __webpack_public_path__ + "img/title_txt_day2.d469e06a.png";